import { WELCOME_PHRASES_BY_LANG } from '../../pages/WinCombo/ComboWelcome/components/phrases';

export type WelcomePhraseLang = keyof typeof WELCOME_PHRASES_BY_LANG;

const WELCOME_LANGS = new Set<string>(Object.keys(WELCOME_PHRASES_BY_LANG));

export const normalizeUtmTermForMatch = (raw: string | undefined | null): string => {
  if (raw == null) return '';
  return raw.replaceAll('+', ' ').replace(/[[\]]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
};

export const normalizeBrowserLangForWelcome = (lang: string): string => {
  const primary = (lang || 'en').toLowerCase().trim().split(/[-_]/)[0] || 'en';
  if (primary === 'iw') return 'he';
  return primary;
};

const stripBrackets = (text: string): string =>
  text.replaceAll('[', '').replaceAll(']', '').replace(/\s+/g, ' ').trim();

const toTitleCaseWords = (text: string): string =>
  text
    .toLowerCase()
    .split(/(\s+)/)
    .map((segment) => {
      if (/^\s+$/.test(segment) || segment.length === 0) return segment;
      return segment.charAt(0).toUpperCase() + segment.slice(1);
    })
    .join('');

const capitalizeLatinWords = (text: string): string =>
  text.replace(
    /[a-zA-Z][a-zA-Z'.-]*/g,
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
  );

const formatHeading = (phrase: string, lang: WelcomePhraseLang): string => {
  const base = stripBrackets(phrase);
  if (lang === 'zh' || lang === 'ja') {
    return capitalizeLatinWords(base);
  }
  return toTitleCaseWords(base);
};

export const getWelcomeTitle = (
  utmRaw: string | undefined | null,
  browserLangRaw: string,
): string | null => {
  const term = normalizeUtmTermForMatch(utmRaw);
  if (!term) return null;

  const browserLang = normalizeBrowserLangForWelcome(browserLangRaw);
  if (!WELCOME_LANGS.has(browserLang)) return null;

  const lang = browserLang as WelcomePhraseLang;
  const phrases = WELCOME_PHRASES_BY_LANG[lang];

  for (const phrase of phrases) {
    if (normalizeUtmTermForMatch(phrase) === term) {
      return formatHeading(phrase, lang);
    }
  }

  return null;
};
